var map = {
	"./pay_ali.png": "wAuX",
	"./pay_ali_active.png": "BbDR",
	"./pay_union.png": "SM61",
	"./pay_union_active.png": "xUQ7",
	"./pay_wx.png": "bDrN",
	"./pay_wx_active.png": "IIK1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+PZv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/pay ^\.\/.*\.png$
// module id = +PZv
// module chunks = 1